import { render, staticRenderFns } from "./quickMenuManageList.vue?vue&type=template&id=aa987a4c&scoped=true"
import script from "./quickMenuManageList.vue?vue&type=script&lang=js"
export * from "./quickMenuManageList.vue?vue&type=script&lang=js"
import style0 from "./quickMenuManageList.vue?vue&type=style&index=0&id=aa987a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa987a4c",
  null
  
)

export default component.exports